<style scoped lang="scss" type="text/scss">
    .content-container {
        .add-buttons {
            display: flex;
        }

        .table-container {
            margin: 1rem 0;
        }
    }
</style>

<template>
    <div class="content-container">
        <div class="add-buttons">
            <el-button plain type="primary" @click="searchAdd">添加成员</el-button>
            <el-button plain type="primary" v-if="creatable" @click="createAdd">创建用户并添加成员</el-button>
        </div>

        <div class="table-container global-relative">
            <loading-placeholder :loading="requesting"></loading-placeholder>
            <el-table :data="members" stripe border size="small" style="width: 100%">
                <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                <el-table-column prop="personal_name" label="姓名" align="center" min-width="100"></el-table-column>
                <el-table-column label="队内职责（ 不影响证书发放 ）" align="center" min-width="120">
                    <template slot-scope="scope">
                        <player-responsibility-selector v-model="scope.row.responsibility"
                                                        placeholder="请选择职责（ 可自定义 ）">
                        </player-responsibility-selector>
                    </template>
                </el-table-column>
                <el-table-column prop="personal_gender_text" label="性别" align="center" min-width="60"></el-table-column>
                <el-table-column prop="personal_role_text" label="个人身份" align="center" min-width="60"></el-table-column>
                <el-table-column prop="type_text" label="队内身份" align="center" min-width="60"></el-table-column>
                <el-table-column prop="create_time_text" label="入队时间" align="center" width="150"></el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" plain
                                   @click="remove(scope.row)"
                                   :disabled="scope.row.type === studentLeaderType"
                                   :loading="scope.row.id === deleteRequestingId && deleteRequesting"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div>
            <el-button type="primary" plain @click="update()" :loading="updateRequesting">确认</el-button>
            <el-button @click="reset()">重置</el-button>
        </div>

        <search-add-popup :visible.sync="searchAddPopupVisible"
                          @need-reload="loadMembers"
        >
        </search-add-popup>

        <create-add-popup :visible.sync="createAddPopupVisible"
                          @need-reload="loadMembers"
        >
        </create-add-popup>
    </div>
</template>

<script>
    import SearchAddPopup from './search-add-popup';
    import CreateAddPopup from './create-add-popup';
    import PlayerResponsibilitySelector from '../../../sub-components/player-responsibility-selector/index';
    import {mapState} from 'vuex';
    import {handlePlayerMembers} from '../../../../utils/data-handler';
    import _ from 'lodash';
    import {PLAYER_MEMBER_TYPE_VALUE_MAP} from '../../../../constant/player-member-type';

    export default {
        name: '',
        components: {
            SearchAddPopup,
            CreateAddPopup,
            PlayerResponsibilitySelector
        },
        props: {
            creatable: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                responsibilityLimit: 15,
                requesting: false,
                members: [],
                updateRequesting: false,
                searchAddPopupVisible: false,
                createAddPopupVisible: false,
                withCreate: false,
                deleteRequestingId: null,
                deleteRequesting: false,
                studentLeaderType: PLAYER_MEMBER_TYPE_VALUE_MAP.STUDENT_LEADER
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadMembers();
                }
            }
        },
        methods: {
            loadMembers () {
                this.$normalRequest('player/loadMembers', {
                    id: this.currentManagedPlayerId
                }, false, false, this, 'requesting').then(data => {
                    this.members = handlePlayerMembers(_.cloneDeep(data));
                });
            },
            update () {
                for (const index in this.members) {
                    const current = this.members[index].responsibility;
                    if (current !== null && current !== undefined && current.length > this.responsibilityLimit) {
                        this.$tip(`成员队内职责不能超过 ${this.responsibilityLimit} 个字`);
                        return;
                    }
                }
                this.$normalRequest('player/updateMembersResponsibility', {
                    id: this.currentManagedPlayerId,
                    members: this.members
                }, '成员职责更新成功', true, this, 'updateRequesting').then(data => {
                    this.loadMembers();
                });
            },
            reset () {
                this.loadMembers();
            },
            searchAdd () {
                this.searchAddPopupVisible = true;
            },
            createAdd () {
                this.createAddPopupVisible = true;
            },
            remove (row) {
                if (row.type === this.studentLeaderType) {
                    this.$tip('无法删除学生队长');
                    return;
                }
                this.$deleteConfirm().then(_ => {
                    const id = row.id;
                    this.deleteRequestingId = id;
                    this.$normalRequest('player/deleteMember', {
                        id
                    }, '成员删除成功', true, this, 'deleteRequesting').then(data => {
                        this.loadMembers();
                        this.deleteRequestingId = null;
                    }).catch(_ => {
                        this.deleteRequestingId = null;
                    });
                }).catch(_ => {
                });
            }
        }
    };
</script>
